<div class="page-container">
  <div class="relative page-edge-cut">
    <div class="form-card">
      <form [formGroup]="form">
         <!-- Action for show notes -->       
        @if (srNumber && srInprgoressAwating && !loadingSrDetail) {
          <app-validation-message
            type="info"
            [content]="{
              title: 'SECTION_NOTES' | translate,
              message: 'SECTION_NOTES_DESCRIPTION' | translate
            }"
            [showbutton]="false"
            [buttonText]="'VIEW_NOTES' | translate"
            (onBtnClick)="showNotes = true"
          />
        }   
        
        <section class="space-y-10">
          <h1 class="section-heading">
            {{ "ATA_CARNET.REFUND.TITLE" | translate }}
          </h1>
          @if (!selected) {
          <div>
            <div class="fields-container">
              <p
                class="text-sm text-gray-600 mb-6"
                translate="ATA_CARNET.REFUND.INTRO"
              ></p>
              <p class="mb-1 font-medium">
                {{ "ATA_CARNET.REFUND.SERVICE_FEES_LABEL" | translate }}
              </p>
              <p class="mb-6 text-dc-navy font-semibold">
                {{ "ATA_CARNET.REFUND.SERVICE_FEES_VALUE" | translate }}
              </p>
              <p
                class="mb-8 text-sm"
                translate="ATA_CARNET.REFUND.STEP_HINT"
              ></p>
              <div class="border border-gray-300 rounded-sm overflow-x-auto">
                <table class="w-full text-sm text-dc-navy">
                  <caption
                    class="bg-gray-200 text-dc-navy text-lg font-semibold text-left p-3"
                  >
                    {{
                      "ATA_CARNET.REFUND.TABLE_CAPTION" | translate
                    }}
                    ({{
                      carnetNumberList.length
                    }})
                  </caption>
                  <thead>
                    <tr class="border-b border-dc-navy text-left">
                      <th class="px-4 py-2">
                        {{ "ATA_CARNET.REFUND.CARNET_NO" | translate }}
                      </th>
                      <th class="px-4 py-2">
                        {{ "ATA_CARNET.REFUND.CARNET_HOLDER" | translate }}
                      </th>
                      <th class="px-4 py-2">
                        {{ "ATA_CARNET.REFUND.EXPIRY_DATE" | translate }}
                      </th>
                      <th class="px-4 py-2"></th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (c of carnetNumberList; track c) {
                    <tr class="border-b border-dc-navy">
                      <td class="px-4 py-3">{{ c.number }}</td>
                      <td class="px-4 py-3">{{ c.holder }}</td>
                      <td class="px-4 py-3">{{ c.expiry }}</td>
                      <td class="px-4 py-3">
                        <app-button
                          [classesName]="'card-edge-cut-white'"
                          [type]="'button'"
                          [label]="'ATA_CARNET.REFUND.APPLY_BTN' | translate"
                          (onBtnClick)="startRefund(c)"
                        />
                      </td>
                    </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          } @if (selected) {
          <p class="px-2">
            {{ "ATA_CARNET.REFUND.REFURND_DESC" | translate }}
          </p>
          @if(step >= 1){
          <div class="fields-container">
            <!-- info note -->
            <!-- <div class="field-control">
              <app-validation-message
                type="info"
                [content]="{
                  title: 'ATA_CARNET.REFUND.NOTE_TITLE' | translate,
                  message: 'ATA_CARNET.REFUND.NOTE_TEXT' | translate
                }"
              />
            </div> -->
            <div class="field-control">
              <app-option-field
                [control]="form.get('carnetNo')"
                [label]="'ATA_CARNET.REFUND.CARNET_NUMBER' | translate"
                [options]="carnetNumberList"
                [labelKey]="'Name'"
                (onSelectionChange)="onCarnetChange($event)"
                [loading]="loadingCarnetList"
              >
              </app-option-field>
            </div>
            <!-- Refund Deposit Amount -->
             @if (securityAmount && securityAmount > 0) {
                <app-validation-message
                    [type]="'info'"
                    [content]="{
                      title: 'VALIDATION_MSG.ATA_REFUND_DEPOSIT_TITLE' | translate : {deposit_amt:securityAmount},
                      message: 'VALIDATION_MSG.ATA_REFUND_DEPOSIT_DESC' | translate
                    }"
                    [showbutton]="false"
                ></app-validation-message>
              }

             @if(expiredCarnetMsg){
              <app-validation-message
                [type]="'error'"
                [content]="{
                  title: 'VALIDATION_MSG.ERROR' | translate,
                  message: 'VALIDATION_MSG.CARNET_EXPIRED' | translate
                }"
                [showbutton]="false"
              ></app-validation-message>
              }
               @if(technicalErrorMsg){
              <app-validation-message
                [type]="'error'"
                [content]="{
                  title: 'VALIDATION_MSG.ERROR' | translate,
                  message: 'TOAST_MESSAGES.TECHNICAL_ERROR' | translate
                }"
                [showbutton]="false"
              ></app-validation-message>
              }
              @if(copyCarnetErrorMsg){
              <app-validation-message
                [type]="'error'"
                [content]="{
                  title: 'VALIDATION_MSG.ERROR' | translate,
                  message: copyCarnetErrorMsg
                }"
                [showbutton]="false"
              ></app-validation-message>
              }
              
          </div>
          } @if (loadingSrDetail) {
          <app-skeleton-loader></app-skeleton-loader>
          } @if (!loadingSrDetail) {
          <ng-container>
            <!-- Bank details --------->
            @if(step >= 2){
            <section>
              <h1 class="section-heading">
                {{ "ATA_CARNET.REFUND.BANK_TITLE" | translate }}
              </h1>
              <p class="px-2">
                {{ "ATA_CARNET.REFUND.BANK_DESC" | translate }}
              </p>
              <div class="fields-container">
                <div class="field-control">
                  <app-text-field
                    [control]="form.get('accountName')"
                    [label]="'ATA_CARNET.REFUND.ACCOUNT_NAME' | translate"
                    [maxlength]="350"
                  />
                </div>
                <div class="field-control">
                  <app-option-field
                    [control]="form.get('bankName')"
                    [label]="'ATA_CARNET.REFUND.BANK_NAME' | translate"
                    [lovType]="lookupKey.XX_BANK_CODES"
                    (onSelectionChange)="onBankChange($event)"
                  >
                  </app-option-field>
                </div>
                @if (form.get('bankName')?.value == fieldValue.OTHER_BANK ||
                form.get('bankName')?.value == fieldValue.OTHER_BANK_AR) {
                <div class="field-control">
                  <app-text-field
                    [control]="form.get('otherBankName')"
                    [label]="'ATA_CARNET.REFUND.OTHER_BANK_NAME' | translate"
                    [maxlength]="150"
                  >
                  </app-text-field>
                </div>
                }
                <div class="field-control">
                  <app-text-field
                    [control]="form.get('bankLocation')!"
                    [label]="'ATA_CARNET.REFUND.BANK_LOCATION' | translate"
                    [maxlength]="100"
                  />
                </div>

                <div class="field-control">
                  <app-text-field
                    [control]="form.get('iban')!"
                    [label]="'ATA_CARNET.REFUND.IBAN' | translate"
                    [maxlength]="34"
                  />
                </div>
                <div class="field-control">
                  <app-text-field
                    [control]="form.get('swift')"
                    [label]="'ATA_CARNET.REFUND.SWIFT' | translate"
                    [maxlength]="100"
                  />
                </div>
              </div>
            </section>
            }
            <!-- Upload documents -------->
            @if(step >= 2){
            <section>
              <h1 class="section-heading">
                {{ "ATA_CARNET.REFUND.UPLOAD_TITLE" | translate }}
              </h1>
              <div class="px-2 hidden">
                <p [innerHTML]="'DOCUMENT_NOTE' | translate"></p>
              </div>
              <div class="fields-container">
              @if(loadingDoc){
                <app-skeleton-loader [formLoader]="true" [noOfFields]="3"></app-skeleton-loader>
              }
              @if (srFolder && !loadingDoc) {
               @for (dt of srFolder.allowedDocumentTypes;
                track $index) {
                <div class="field-control">
                  <app-file
                    #fileCmp
                    [title]="lang == 'en' ? dt.nameEn : dt.nameAr"
                    [control]=""
                    [documentType]="dt.nameEn"
                    (folderMissing)="openFolder()"
                    [showAction]="showActions"
                    [folder]="srFolder"
                    [documentServiceType]="documentServiceType.ATA_CARNET"
                    [stampLocationRequirement]="dt?.stampLocationRequirement || 'NOT_APPLICABLE'"
                  ></app-file>
                </div>
                } }
              </div>
            </section>
            <!-- comments -->
            <section>
              <div class="fields-container">
                <div class="field-control">
                  <app-text-field
                    type="big-text"
                    [placeholder]="
                      'ATA_CARNET.REFUND.COMMENTS_PLACEHOLDER' | translate
                    "
                    [control]="form.get('comments')"
                    [label]="'ATA_CARNET.REFUND.COMMENTS' | translate"
                    [maxlength]="200"
                  />
                </div>
                <!--T & C    ═-->
                <div class="field-control">
                  <label
                    class="flex items-center gap-5 lg:gap-x-2 cursor-pointer relative"
                  >
                    <input
                      formControlName="agree"
                      type="checkbox"
                      class="peer form-checkbox h-6 w-6 text-dc-navy border-dc-navy accent-dc-navy rounded-none"
                    />
                    <span
                      class="h-6 w-6 font-sans text-white text-sm text-center pt-0.25 absolute bg-white border border-dc-navy peer-checked:bg-dc-navy"
                    >
                      <i class="fas fa-check"></i>
                    </span>
                    <span
                      class="text-sm text-dc-navy"
                      (click)="openTermsCondition()"
                      [innerHTML]="'ATA_CARNET.AGREEMENT' | translate"
                    ></span>
                  </label>
                  @if( form.get('agree')?.touched &&
                  form.get('agree')?.hasError('required')){
                  <div class="fields-error-container">
                    {{ "VALIDATION_MSG.FIELD_REQUIRED" | translate }}
                  </div>
                  }
                </div>
              </div>
            </section>
            }

            <!-- Error Message -->
            @if (errorMsg) {
              <app-validation-message
                [type]="'error'"
                [content]="{
                  title: 'ALERT.ERROR' | translate,
                  message: errorMsg
                }"
              >
              </app-validation-message>
            }
            @if(technicalErrorMsg){
            <app-validation-message
              [type]="'error'"
              [content]="{
                title: 'VALIDATION_MSG.ERROR' | translate,
                message: 'TOAST_MESSAGES.TECHNICAL_ERROR' | translate
              }"
              [showbutton]="false"
            ></app-validation-message>
            }
            <!--Action buttons   ═-->
            <div class="btn-section buttons-group">
              @if(!formSubmitLoader && showActions){
              <app-button
                type="button"
                [label]="'BUTTONS.SUBMIT' | translate"
                (onBtnClick)="nextStep()"
                classesName="btn-width-auto"
              />            
              } @if(formSubmitLoader){
              <app-button
                type="button"
                classesName="btn-edge-cut btn-width-auto"
                [label]="'PLEASE_WAIT' | translate"
                [disabled]="true"
              ></app-button>
              }
            </div>
          </ng-container>
          } }
        </section>
      </form>
    </div>
  </div>

  <div>
    <app-service-progress
      [serviceName]="'ATA_CARNET.APPLY_FOR_REFUND' | translate"
      [completePercentage]="formProgress"
    />
  </div>
</div>

@if (successModal) {
<app-sr-submit-success-modal
  [srNumber]="srNumber"
  (onClose)="closeSuccessModal()"
></app-sr-submit-success-modal>
}

<!-- Consent modal -->
@if (termsModal) {
  <app-digital-consent-modal [data]="consentModalData" (onSubmit)="submitPledge($event)"></app-digital-consent-modal>
}

<!-- notes modal -->
@if(showNotes) {
<app-notes [srNumber]="srNumber" [allowSubmit]="true" (onClose)="showNotes = false;"></app-notes>
}

